import {BaseGeometry} from '../models/base-geometry';
import {MmpProjectSettings} from './mmp-format';
import {Layer} from '../models/layer';
import {GeoGroupData} from '../models/geo-group-data';

/**
 * What an import adds to the map. The server reads files now (POST /import,
 * functions' client/manager/import), for every app; this is what the demo,
 * which saves nothing, adds from what the server read (POST /import/preview).
 */
export interface FileImport {
  geometries: BaseGeometry[];
  layers: Layer[];
  groups: GeoGroupData[];
  /** What the file held that could not be brought in, by kind. */
  skipped: {[kind: string]: number};
  /** Project settings an .mmp carried; applied only where the project has none. */
  project?: MmpProjectSettings;
}

/** A file that could not be read as the format its name says (too_large, invalid_file, unsupported). */
export class ImportError extends Error {
  constructor(public readonly code: string, public readonly fileName: string, public readonly extension: string) {
    super(code);
  }
}

/**
 * The files an import reads. Reading them moved to the server (import-manager.ts
 * in the functions); the web app's KML, KMZ, GPX, GeoJSON and .mmp readers went
 * with it, so every app imports a file alike.
 */
export class FileLoader {
  /** Files the server reads (POST /import); pictures and MBTiles maps are added by the app. */
  static readonly DATA_EXTENSIONS = ['mmp', 'kml', 'kmz', 'gpx', 'json', 'geojson', 'topojson'];

  /**
   * The most map data one file may hold, in MB: the server's limits. XML --
   * KML, GPX, .mmp, a KMZ's KML unpacked -- takes far more memory to read
   * than JSON (GeoJSON, TopoJSON).
   */
  static readonly MAX_XML_MB = 100;
  static readonly MAX_JSON_MB = 200;
}
